import request from '../utils/request.js'

export default {
  selectlist (params) {
    return request.post(`template/selectlist`, params).then(res => res.data)
  },
  getList (params) {
    return request.post(`template/lists`, params).then(res => res.data)
  },
  add (params) {
    return request.post(`template/add`, params).then(res => res.data)
  },
  edit (params) {
    return request.post(`template/add`, params).then(res => res.data)
  },
  details (params) {
    return request.post(`template/details`, params).then(res => res.data)
  },
  delete (params) {
    return request.post(`template/del`, params).then(res => res.data)
  },
  get_insert_field (params) {
    return request.post(`template/get_insert_field`, params).then(res => res.data)
  },
  copy (params) {
    return request.post(`template/copy_template`, params).then(res => res.data)
  },
  // 导出模板
  exportTemplate (params) {
    return request.post(`template/export_template`, params).then(res => res.data)
  },
  // 导入模板
  importTemplate (params) {
    return request.post(`template/import_template`, params).then(res => res.data)
  }
}



// WEBPACK FOOTER //
// ./src/api/template.js